const formatter = new Intl.NumberFormat();
const formatNumber = (num: number): string => formatter.format(num);
export default formatNumber;
